import { PropsWithChildren, useState } from 'react'
import { Provider } from 'react-redux'
import { persistStore } from 'redux-persist'
import { PersistGate } from 'redux-persist/integration/react'

import { makeStore } from '@/redux/store'

export const ReduxProvider = ({ children }: PropsWithChildren) => {
  const [store] = useState(() => makeStore())
  const [persistor] = useState(() => persistStore(store))

  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>{children}</PersistGate>
    </Provider>
  )
}
